module.exports = __webpack_public_path__ + "img/Gift_Guide-snow.f3f513f.jpg";